import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-body-2 text-medium-emphasis mt-2" }
const _hoisted_2 = { class: "text-body-2" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }
const _hoisted_4 = {
  key: 0,
  class: "text-caption text-medium-emphasis"
}
const _hoisted_5 = {
  key: 2,
  class: "results-container"
}
const _hoisted_6 = { class: "text-caption" }
const _hoisted_7 = { class: "text-body-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_WaitDialog, {
        isActive: $setup.isWaiting,
        title: "Executing telemetry operations..."
      }, null, 8 /* PROPS */, ["isActive"]),
      _createCommentVNode(" Header Section "),
      _createVNode(_component_v_row, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "pc" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        icon: "mdi-chart-line",
                        class: "mr-2"
                      }),
                      _cache[0] || (_cache[0] = _createTextVNode(" Telemetry Operations Test Guide "))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-body-1" }, " Test and validate all Azure Application Insights telemetry operations. Each card below represents a telemetry method from the TelemetryContract interface. ", -1 /* HOISTED */)),
                      _createElementVNode("p", _hoisted_1, [
                        _createVNode(_component_v_icon, {
                          icon: "mdi-information",
                          size: "small",
                          class: "mr-1"
                        }),
                        _cache[1] || (_cache[1] = _createTextVNode(" Open browser DevTools Console to see detailed execution logs and check Azure Application Insights to verify telemetry data. "))
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_m_btn, {
                        color: "primary",
                        "prepend-icon": "mdi-play-circle",
                        text: "Execute All Operations",
                        onClick: $setup.executeAllOperations,
                        loading: $setup.isExecutingAll
                      }, null, 8 /* PROPS */, ["onClick", "loading"]),
                      _createVNode(_component_m_btn, {
                        color: "secondary",
                        "prepend-icon": "mdi-refresh",
                        text: "Clear Console",
                        onClick: $setup.clearConsole
                      }, null, 8 /* PROPS */, ["onClick"]),
                      _createVNode(_component_m_btn, {
                        "prepend-icon": "mdi-broom",
                        text: "Flush Telemetry",
                        onClick: $setup.flushTelemetry
                      }, null, 8 /* PROPS */, ["onClick"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Telemetry Operations Grid "),
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.telemetryOperations, (op) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: op.name,
              cols: "12",
              md: "6",
              lg: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  class: _normalizeClass(op.executed ? 'tc' : ''),
                  height: "100%"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-h6" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: op.icon,
                          class: "mr-2"
                        }, null, 8 /* PROPS */, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(op.title) + " ", 1 /* TEXT */),
                        _createVNode(_component_v_spacer),
                        (op.executed)
                          ? (_openBlock(), _createBlock(_component_v_chip, {
                              key: 0,
                              color: "success",
                              size: "small",
                              "prepend-icon": "mdi-check"
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Executed ")
                              ]))]),
                              _: 1 /* STABLE */
                            }))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, _toDisplayString(op.description), 1 /* TEXT */),
                        _createVNode(_component_v_divider, { class: "my-2" }),
                        _createElementVNode("p", _hoisted_3, [
                          _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Method:", -1 /* HOISTED */)),
                          _cache[5] || (_cache[5] = _createTextVNode()),
                          _createElementVNode("code", null, _toDisplayString(op.method), 1 /* TEXT */)
                        ]),
                        (op.severity)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                              _cache[6] || (_cache[6] = _createElementVNode("strong", null, "Severity:", -1 /* HOISTED */)),
                              _createTextVNode(" " + _toDisplayString(op.severity), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" Results Section "),
                        (op.results && op.results.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_divider, {
                              key: 1,
                              class: "my-2"
                            }))
                          : _createCommentVNode("v-if", true),
                        (op.results && op.results.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(op.results, (result, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: _normalizeClass(["result-item", result.success ? 'text-success' : 'text-error'])
                                }, [
                                  _createVNode(_component_v_icon, {
                                    icon: result.success ? 'mdi-check-circle' : 'mdi-alert-circle',
                                    color: result.success ? 'success' : 'error',
                                    size: "small",
                                    class: "mr-1"
                                  }, null, 8 /* PROPS */, ["icon", "color"]),
                                  _createElementVNode("span", _hoisted_6, [
                                    _createElementVNode("strong", null, _toDisplayString(result.timestamp) + ":", 1 /* TEXT */),
                                    _createTextVNode(" " + _toDisplayString(result.message), 1 /* TEXT */)
                                  ])
                                ], 2 /* CLASS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        (op.results && op.results.length > 0)
                          ? (_openBlock(), _createBlock(_component_m_btn, {
                              key: 0,
                              text: "Clear",
                              size: "small",
                              onClick: ($event: any) => (op.results = [])
                            }, null, 8 /* PROPS */, ["onClick"]))
                          : _createCommentVNode("v-if", true),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_m_btn, {
                          color: "primary",
                          onClick: op.execute,
                          loading: op.loading
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode(" Execute Now ")
                          ]))]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "loading"])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }),
      _createCommentVNode(" Additional Information "),
      _createVNode(_component_v_row, { class: "mt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panels, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-information-outline",
                            class: "mr-2"
                          }),
                          _cache[8] || (_cache[8] = _createTextVNode(" About Telemetry Operations "))
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-h6 mb-2" }, "Telemetry Contract Methods", -1 /* HOISTED */)),
                          _cache[20] || (_cache[20] = _createElementVNode("ul", { class: "text-body-2" }, [
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "trackEvent:"),
                              _createTextVNode(" Track custom application events like button clicks or user actions")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "trackTrace:"),
                              _createTextVNode(" Log diagnostic traces with different severity levels ")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "trackException:"),
                              _createTextVNode(" Record errors and exceptions with context")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "trackPageView:"),
                              _createTextVNode(" Track page navigation and views")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "trackMetric:"),
                              _createTextVNode(" Record custom performance metrics")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "startTrackEvent/stopTrackEvent:"),
                              _createTextVNode(" Measure operation duration")
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "flush:"),
                              _createTextVNode(" Force immediate send of all buffered telemetry ")
                            ])
                          ], -1 /* HOISTED */)),
                          _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "text-h6 mt-4 mb-2" }, "Severity Levels", -1 /* HOISTED */)),
                          _createElementVNode("ul", _hoisted_7, [
                            _createElementVNode("li", null, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                  _createTextVNode("Verbose")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _cache[10] || (_cache[10] = _createTextVNode(" Detailed diagnostic information"))
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode("Information")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _cache[12] || (_cache[12] = _createTextVNode(" General informational messages"))
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                  _createTextVNode("Warning")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _cache[14] || (_cache[14] = _createTextVNode(" Warning messages for potentially harmful situations"))
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                  _createTextVNode("Error")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _cache[16] || (_cache[16] = _createTextVNode(" Error events that might still allow the application to continue"))
                            ]),
                            _createElementVNode("li", null, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode("Critical")
                                ])),
                                _: 1 /* STABLE */
                              }),
                              _cache[18] || (_cache[18] = _createTextVNode(" Critical failures that require immediate attention"))
                            ])
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}